/**
 * Formats a number according to the specified locale
 * @param value - The number to format
 * @param locale - The locale string (e.g., 'fr-CA', 'en-CA')
 * @param options - Optional Intl.NumberFormatOptions
 * @returns Formatted number string
 */
export function formatNumber(value: number, locale: string, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(locale, options).format(value);
}

/**
 * Formats a number with locale-specific thousands separators
 * @param value - The number to format
 * @param locale - The locale string (e.g., 'fr-CA', 'en-CA')
 * @returns Formatted number string with thousands separators
 */
export function formatNumberWithSeparators(value: number, locale: string): string {
  return formatNumber(value, locale, {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

/**
 * Formats a decimal number with locale-specific formatting
 * @param value - The number to format
 * @param locale - The locale string (e.g., 'fr-CA', 'en-CA')
 * @param decimalPlaces - Number of decimal places to show (default: 2)
 * @returns Formatted decimal number string
 */
export function formatDecimal(value: number, locale: string, decimalPlaces: number = 2): string {
  return formatNumber(value, locale, {
    useGrouping: true,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  });
}
